import { z } from 'zod';

export const defaultWhenNullish = <T extends z.ZodTypeAny, S>(
  schema: T,
  fallback: S
) => schema.nullish().transform(value => value ?? fallback);
